import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { planService } from '../../services/PlanServices';

const PlansList = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const columns = [
    {
      name: 'Category',
      selector: row => row.category,
      sortable: true,
    },
    {
      name: 'Plan Type',
      selector: row => row.planType,
      sortable: true,
    },
    {
      name: 'Investment Range',
      selector: row => `${row.investmentAmount.min} - ${row.investmentAmount.max ?? 'No Limit'}`,
      sortable: true,
    },
    {
      name: 'Profit %',
      selector: row => `${row.profitPercentage.min} - ${row.profitPercentage.max}`,
      sortable: true,
    },
    {
      name: 'Lock-in Period',
      selector: row => `${row.lockInPeriod} ${row.lockInPeriodUnit}`,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => (row.status ? 'Active' : 'Inactive'),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="btn-group" role="group">
          <Link
            to={`/admin/plans/edit/${row._id}`}
            type="button"
            className="btn btn-outline-secondary"
          >
            <i className="icofont-edit text-success"></i>
          </Link>
          <button
            onClick={() => handleDelete(row._id)}
            type="button"
            className="btn btn-outline-secondary deleterow"
          >
            <i className="icofont-ui-delete text-danger"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await planService.getPlanTypesList(); // Should return paginated response
      setPlans(response.data?.data || []);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch plans:', error);
      setError('Failed to load plans.');
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this plan?");
    if (confirmed) {
      try {
        await planService.deletePlan(id);
        fetchPlans();
      } catch (error) {
        console.error('Failed to delete plan:', error);
      }
    }
  };

  if (loading) return <p>Loading plans...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="body d-flex py-3">
      <div className="container-xxl">
        <div className="row align-items-center">
          <div className="border-0 mb-4">
            <div className="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
              <h3 className="fw-bold mb-0">Plans List</h3>
            </div>
          </div>
        </div>
        <div className="row align-item-center">
          <div className="col-md-12">
            <div className="card mb-3">
              <div className="card-header py-3 bg-transparent border-bottom-0">
                <div className="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                  <h6 className="mb-0 fw-bold">Plans</h6>
                  <Link to="/admin/plans/create" className="btn btn-primary step-btn">+ Add New</Link>
                </div>
              </div>
              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={plans}
                  pagination
                  highlightOnHover
                  persistTableHead
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlansList;
